import { Route, Routes } from "react-router-dom";
import HomeProtectedRoute from "./Components/Widgets/LoginPage/HomeProtectedRoute";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomeProtectedRoute />} />

      <Route path="*" element={<HomeProtectedRoute />} />
    </Routes>
  );
}

export default AppRouter;
